/**
 * Грубая эвристика "слабое" устройство/сеть vs "обычное" — единая точка, на которую
 * завязаны размеры первых батчей подгрузки (история сообщений, галерея в инфопанели,
 * preload эмодзи). Экономия трафика/памяти важнее там, где это реально узкое место
 * (мобильные сети, saveData), отзывчивость важнее там, где ресурсов с запасом.
 *
 * Сигнал первого порядка — Network Information API (effectiveType/saveData), она прямо
 * отвечает на вопрос "дорого ли сейчас качать". Она есть не везде (нет в Safari/Firefox) —
 * тогда fallback на ширину вьюпорта (тот же порог 720px, что и в CSS для мобильной раскладки):
 * не идеальный сигнал сам по себе (мобильный не значит медленный), но не нулевой — мобильные
 * профили чаще ограничены и по трафику, и по памяти устройства.
 *
 * Считается один раз при загрузке модуля: значение используется только для размеров ПЕРВЫХ
 * батчей подгрузки, реагировать на изменения (поворот экрана, смена сети) посреди уже
 * идущей пагинации не нужно — а на следующей перезагрузке страницы профиль пересчитается сам.
 */
export type LoadProfile = 'low' | 'high';

interface NetworkInformation {
  saveData?: boolean;
  effectiveType?: string;
}

function detectLowEnd(): boolean {
  const nav = typeof navigator !== 'undefined' ? navigator : undefined;
  const conn = (nav as unknown as { connection?: NetworkInformation } | undefined)?.connection;
  if (conn) {
    if (conn.saveData) return true;
    if (conn.effectiveType && /^(slow-2g|2g|3g)$/.test(conn.effectiveType)) return true;
    return false;
  }
  return typeof window !== 'undefined' && window.innerWidth <= 720;
}

export const loadProfile: LoadProfile = detectLowEnd() ? 'low' : 'high';

/** История сообщений чата (api/chats.ts history()) — первая и последующие страницы. */
export const MESSAGE_PAGE_SIZE = loadProfile === 'low' ? 30 : 50;

/** Галерея вложений в инфопанели (api/chats.ts getChatGallery()) — Медиа/Музыка/Голосовые/Файлы. */
export const GALLERY_PAGE_SIZE = loadProfile === 'low' ? 18 : 30;

/** Сколько строк каждой категории эмодзи-пикера подгружать заранее, до открытия/пролистывания. */
export const EMOJI_PRELOAD_ROWS = loadProfile === 'low' ? 4 : 8;
